import { ELEMENT_TYPE, Element } from '@vindr/services/apis/element.api';
import DateTimeElement, { DatetimeElementProps } from '../datetime/DateTimeElement';
import GenerateListElement, {
  GenerateListElementProps,
} from '../generate-list/GenerateListElement';
import ImageElement, { ImageElementProps } from '../image/ImageElement';
import InputElement, { InputElementProps } from '../input/InputElement';
import SelectionElement, { SelectionElementProps } from '../selection/SelectionElement';
import StructuredElement, { StructuredElementProps } from '../structured/StructuredElement';
import { StructuredReportElement } from '../types';

export class ElementFactory {
  private static elementCache = new Map<string, StructuredReportElement>();
  private static visited = new Set<string>();

  public static createElement(
    props:
      | (Element & {
          parent?: StructuredElement | SelectionElement | GenerateListElement;
          level?: number;
        })
      | StructuredReportElement
  ): StructuredReportElement {
    if ((props.parent?.level ?? 0) >= 20) {
      console.log("Can't go deeper than 20 levels", props);
      return null;
    }

    if (!props.id) {
      console.error('Element has no ID', props);
      return;
    }

    let element: StructuredReportElement;

    switch (props?.type) {
      case ELEMENT_TYPE.INPUT_TEXT:
        element = new InputElement(props as InputElementProps);
        break;
      case ELEMENT_TYPE.DROPDOWN_LIST:
        element = new SelectionElement(props as SelectionElementProps);
        break;
      case ELEMENT_TYPE.STRUCTURE:
        element = new StructuredElement(props as unknown as StructuredElementProps);
        break;
      case ELEMENT_TYPE.DATE_TIME:
        element = new DateTimeElement(props as DatetimeElementProps);
        break;
      case ELEMENT_TYPE.IMAGE:
        element = new ImageElement(props as ImageElementProps);
        break;
      case ELEMENT_TYPE.GENERATED_LIST:
        element = new GenerateListElement(props as unknown as GenerateListElementProps);
        break;
      default:
        console.error(`Unsupported element type: `, props);
        throw new Error(`Unsupported element type: ${props.type}`);
    }

    this.elementCache.set(props.id, element);
    this.visited.add(props.id);

    return element;
  }
}
